import styles from './TextWithIconCard.module.css';
import { Icon, IconName } from '../../ui/Icon/Icon';

type TextWithIconCardProps = {
  heading: string;
  text: string;
  iconName: IconName;
};

export const TextWithIconCard = ({ heading, text, iconName }: TextWithIconCardProps) => {
  return (
    <div className={styles.cardLayout}>
      <Icon iconName={iconName} className={styles.cardIconContainer} />
      <div className={styles.cardDescriptionContainer}>
        <p className={styles.cardHeading}>{heading}</p>
        <p className={styles.cardDescription}>{text}</p>
      </div>
    </div>
  );
};
